import React from "react";

export const DoubleThumbsUpIcon = ({
  className,
  isActive,
}: {
  className?: string;
  isActive?: boolean;
}) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 36 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    role="img"
    aria-hidden="true"
  >
    {/* Back thumb */}
    <path
      d="M9 22H18C18.83 22 19.54 21.5 19.84 20.78L22.86 12.73C22.95 12.5 23 12.26 23 12V10C23 8.9 22.1 8 21 8H14.69L15.64 3.43C15.66 3.33 15.67 3.23 15.67 3.12C15.67 2.7 15.5 2.33 15.23 2.06L14.17 1L7.58 7.59C7.22 7.95 7 8.45 7 9V20C7 21.1 7.9 22 9 22Z"
      fill={isActive ? "currentColor" : "none"}
      stroke="currentColor"
      strokeWidth="2.5"
      opacity="0.7"
      transform="translate(10, -2)"
    />
    {/* Front thumb with stroke */}
    <path
      d="M9 22H18C18.83 22 19.54 21.5 19.84 20.78L22.86 12.73C22.95 12.5 23 12.26 23 12V10C23 8.9 22.1 8 21 8H14.69L15.64 3.43C15.66 3.33 15.67 3.23 15.67 3.12C15.67 2.7 15.5 2.33 15.23 2.06L14.17 1L7.58 7.59C7.22 7.95 7 8.45 7 9V20C7 21.1 7.9 22 9 22Z"
      fill={isActive ? "currentColor" : "white"}
      stroke="currentColor"
      strokeWidth="2.5"
      transform="translate(-2, 0)"
    />
  </svg>
);
